import React from 'react';
import { ROLES } from '../../../constants';
import { useSelector } from 'react-redux';
import MerchantHome from './MerchantHome';
import CarrierHome from './CarrierHome';
import AdminHome from './AdminHome';

const HomePage = () => {
  const userRole = useSelector((state: any) => state.auth.user.role);
  if (!userRole) return <></>;
  if (userRole === ROLES.CARRIER_USER) {
    return <CarrierHome />;
  } else if (userRole === ROLES.COMPANY_OWNER || userRole === ROLES.LOCATION_USER) {
    return <MerchantHome />;
  } else if (userRole === ROLES.ADMIN) {
    return <AdminHome />;
  } else {
    return <></>;
  }
};

export default HomePage;
